import { render } from "./CommunityDashboard.vue?vue&type=template&id=1bc30e49&scoped=true"
import script from "./CommunityDashboard.vue?vue&type=script&lang=js"
export * from "./CommunityDashboard.vue?vue&type=script&lang=js"

import "./CommunityDashboard.vue?vue&type=style&index=0&id=1bc30e49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc30e49"]])

export default __exports__